<div class="tw-flex tw-space-x-1">
  <call-button *ngIf="!hideCallButton" [borrowerId]="borrowerId"></call-button>
  <app-sms-button-menu *ngIf="!hideSmsButton" [borrowerId]="borrowerId"></app-sms-button-menu>
  <app-email-button-menu *ngIf="!hideEmailButton" [borrowerId]="borrowerId"></app-email-button-menu>
</div>
